import React from "react";
import { Button, Image } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import { SET_CALLING_INFO } from "../../../../../store/types";
import Alert from "react-s-alert";
import isEmpty from "../../../../../store/validation/is-Empty";

const CallingIconButtonActionFile = (props) => {
  const dispatch = useDispatch();

  const callingDataPoup = useSelector((state) => {
    return !isEmpty(state.vendorOrdering)
      ? state?.vendorOrdering?.callingInfo
      : "";
  });

  const sendDataFunction = (data) => {
    if (callingDataPoup === null) {
      let firstAndLastName = (data?.first_name || data?.firstName) + " " + (data?.last_name || data?.lastName);
      let combinedName = data?.name || (data?.first_name || data?.firstName);
      let formData = {
        modelActive: true,
        userName:
          props.actionType === "conbinedName" ? combinedName : firstAndLastName,
        country_code: data?.country_code || data?.countryCode,
        mobile_number: data?.mobile_number || data?.mobileNumber,
      };
      dispatch({ type: SET_CALLING_INFO, payload: formData });
    } else {
      Alert.error(`<h4>Please closed already running calling request</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    }
    // return formData;
  };

  return (
    <React.Fragment>
      <Button
        variant="link"
        className={"enIconBtn mr-3"}
        onClick={() => sendDataFunction(props?.orderDetails)}
      >
        <Image
          src={require("../../../../../assets/images/UserManagement/phone.svg")}
          alt="Call"
          title="Calling Button"
          fluid
        />
      </Button>
    </React.Fragment>
  );
};

export default CallingIconButtonActionFile;
